import * as React from "react";
const SvgChevron = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 6L8 12L14 18", stroke: "#EFEEF0", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgChevron;
